import React, { useEffect } from 'react';

const PrimeRequiredModalV2 = ({
    isOpen,
    optionLabel,
    loading = false,
    brokerMode = false,
    onCancel,
    onConfirm,
}) => {
    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const handleEscape = (event) => {
            if (event.key === 'Escape' && !loading) {
                onCancel?.();
            }
        };

        window.addEventListener('keydown', handleEscape);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, loading, onCancel]);

    if (!isOpen) {
        return null;
    }

    const resolvedOptionLabel = optionLabel || 'This business type';

    return (
        <div
            className='business-v2-prime-modal'
            role='dialog'
            aria-modal='true'
            aria-labelledby='business-v2-prime-modal-title'
            onClick={loading ? undefined : onCancel}
        >
            <div
                className='business-v2-prime-modal__backdrop'
                aria-hidden='true'
            />
            <div
                className='business-v2-prime-modal__card'
                onClick={(event) => event.stopPropagation()}
            >
                <button
                    type='button'
                    className='business-v2-prime-modal__close'
                    onClick={onCancel}
                    disabled={loading}
                    aria-label='Close'
                >
                    <span aria-hidden='true'>&times;</span>
                </button>

                {brokerMode ? (
                    <>
                        <h3 id='business-v2-prime-modal-title' className='business-v2-prime-modal__title'>
                            Not available in this phase
                        </h3>
                        <p className='business-v2-prime-modal__copy'>
                            <strong>{resolvedOptionLabel}</strong> requires a Business Prime application.
                            The broker portal currently supports <strong>Business Plus</strong> applications only.
                            Please choose a different business type, or contact FV Bank to onboard this client.
                        </p>

                        <div className='business-v2-prime-modal__actions'>
                            <button
                                type='button'
                                className='business-v2-prime-modal__button business-v2-prime-modal__button--primary'
                                onClick={onCancel}
                                disabled={loading}
                            >
                                Choose a different business type
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h3 id='business-v2-prime-modal-title' className='business-v2-prime-modal__title'>
                            Business Prime is required
                        </h3>
                        <p className='business-v2-prime-modal__copy'>
                            <strong>{resolvedOptionLabel}</strong> requires a Business Prime application.
                            If you continue, this application will be switched to Business Prime and you can proceed with the Prime flow.
                        </p>

                        <div className='business-v2-prime-modal__actions'>
                            <button
                                type='button'
                                className='business-v2-prime-modal__button business-v2-prime-modal__button--secondary'
                                onClick={onCancel}
                                disabled={loading}
                            >
                                Stay on Business Plus
                            </button>
                            <button
                                type='button'
                                className='business-v2-prime-modal__button business-v2-prime-modal__button--primary'
                                onClick={onConfirm}
                                disabled={loading}
                            >
                                Continue with Business Prime
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PrimeRequiredModalV2;
